require('./addNetworkDialog.style.scss');

const HELP_VM_CLONE_NETWORKS = 'VM-clone-network';
const HELP_EC_DEPLOY_NETWORKS = 'HYCU-BC-deployment-network';
class AddNetworkDialogController {
    constructor($scope, $timeout, $filter, $attrs, ecDeployPersistence) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$attrs = $attrs;
        this.subnetsList = [];
        this.subnet = null;
        this.externalIp = false;
        this.persistence = ecDeployPersistence;
    }

    $onInit() {
        this.helpId =
            this.$attrs.eventId !== 'recoverVm-network-azure' ? HELP_EC_DEPLOY_NETWORKS : HELP_VM_CLONE_NETWORKS;
        this.externalIp = this.selectedNetwork ? this.selectedNetwork.publicIP : false;

        this.id = this.$attrs.eventId + '-close';
        this.closeId = {
            close: this.$attrs.eventId + '-close',
            closeIcon: this.$attrs.eventId + '-close-icon',
            closeTitle: this.$filter('translate')('common.form.default.btn.close.label'),
        };
        this.actionButton = [
            {
                title: this.$filter('translate')('ec.deploy.networkDialog.add.button'),
                action: () => this.saveNetwork(),
                isDisabled: () => this.isAddDisabled(),
                id: this.$attrs.eventId + '-start',
                type: 'submit',
            },
        ];

        this.networkSearch = {};
        this.subnetSearch = {};
        this.externalAddSearch = {};

        this.isAdding = false;

        this.networksList = this.allNetworksList;
        this.initNetworkProperties();
        this.initNetworkWatchers();
    }

    onOpen() {
        if (this.editMode) {
            this.modalTitle = this.$filter('translate')('ec.deploy.networkDialog.network.edit');
            this.actionButton[0].title = this.$filter('translate')('ec.deploy.networkDialog.save.button');
            this.allSubnets = this.networksList[0].subnetsList;
            this.subnetsList = this.networksList[0].subnetsList;
            this.subnet = this.subnetsList[0];
            // .filter(i => !i.isAdded).map(i => { return i });
        } else {
            this.modalTitle = this.$filter('translate')('ec.deploy.networkDialog.network.add');
            // let tempList = this.networksList.filter(net => {
            //     if (net.subnetsList.filter(i => i.isAdded).lenght > 0) return net;
            // });
            // this.networksList = tempList && tempList.length > 0 ? tempList : this.networksList;
            if (this.networksList && this.networksList.length === 1) {
                this.selectedNetwork = this.networksList[0];
                this.onNetworkChanged();
            }
        }
    }

    onNetworkChanged() {
        this.subnet = null;
        this.subnetsList = [];
        this.busyNetwork = true;
        this.$timeout(() => {
            // this.subnetsList = this.selectedNetwork.subnetsList.filter(i => !i.isAdded);
            this.allSubnets = this.selectedNetwork.subnetsList;
            this.subnetsList = this.selectedNetwork.subnetsList;
            this.busyNetwork = false;
        }, 500);
    }

    saveNetwork() {
        //this.busy = this.onSave({internalAddress: null, externalAddress: null, selectedInternal: null, selectedExternal: null, subnetType: this.subnet.value}).then(() => {
        this.isAdding = true;
        let dataObj = {
            publicIpType: this.selectedExternal[0],
            publicIp: this.externalAddress && this.showExternalAddresses ? this.externalAddress : null,
            privateIpType: this.selectedInternal[0],
            privateIpRange: this.internalIp && this.showInternalIpAddress ? this.internalIp : null,
            subnet: this.subnet,
        };
        this.busyNetwork = this.onSave(dataObj).then(
            () => {
                this.showModal = false;
                this.onClose();
                this.isAdding = false;
            },
            (err) => {
                this.isAdding = false;
            }
        );
    }

    onClose() {
        delete this.subnet;
        this.networksList = [];
        this.allNetworksList = [];
        this.allSubnets = [];
        this.subnetsList = [];
        this.showModal = false;
    }

    initNetworkProperties() {
        this.availableExternalOptions = [
            {
                id: 'none-external-tag',
                label: this.$filter('translate')('ec.deploy.externalTag.none'),
                color: 'ec-deploy-external-none',
                value: 'NONE',
                selected: false,
            },
            {
                   id: 'ephemeral-external-tag',
                   label: this.$filter('translate')('ec.deploy.externalTag.dynamic'),
                   color: 'ec-deploy-external-dynamic',
                   value: 'DYNAMIC',
                   selected: false,
            }, 
            {
                id: 'static-external-tag',
                label: this.$filter('translate')('ec.deploy.externalTag.static'),
                color: 'ec-deploy-external-static',
                value: 'STATIC',
                selected: false,
            },
            {
                id: 'existing-external-tag',
                label: this.$filter('translate')('ec.deploy.externalTag.existing'),
                color: 'ec-deploy-external-existing',
                value: 'EXISTING',
                selected: false,
            },
        ];

        if (this.availabilityZone && this.availabilityZone.value !== 'None') {
            this.availableExternalOptions.splice(1, 1);
        }

        this.availableInternalOptions = [
            {
                id: 'dynamic-internal-tag',
                label: this.$filter('translate')('ec.deploy.internalTag.dynamic'),
                color: 'ec-deploy-external-none',
                value: 'DYNAMIC',
                selected: false,
            },
            {
                id: 'static-internal-tag',
                label: this.$filter('translate')('ec.deploy.internalTag.static'),
                color: 'ec-deploy-external-dynamic',
                value: 'STATIC',
                selected: false,
            },
        ];
        this.selectedInternal = [];
        this.selectedExternal = [];
    }

    initNetworkWatchers() {
        this.$scope.$watch(
            () => this.selectedNetwork,
            (newNetwork) => {
                this.availableExternalOptions.forEach((tag) => {
                    tag.selected = false;
                });
                this.availableInternalOptions.forEach((tag) => {
                    tag.selected = false;
                });
                this.selectedInternal = [];
                this.selectedExternal = [];
                if (newNetwork) {
                    let extrnalTag = newNetwork.ipConfiguration
                        ? this.availableExternalOptions.filter((tag) => {
                            return tag.value === newNetwork.ipConfiguration.publicIpType;
                        })
                        : this.availableExternalOptions;
                    let externalIndex = newNetwork.ipConfiguration
                        ? this.availableExternalOptions.findIndex((tag) => {
                            return tag.value === newNetwork.ipConfiguration.publicIpType;
                        })
                        : 0;

                    let internalTag = newNetwork.ipConfiguration
                        ? this.availableInternalOptions.filter((tag) => {
                            return tag.value === newNetwork.ipConfiguration.privateIpType;
                        })
                        : this.availableInternalOptions;
                    let internalIndex = newNetwork.ipConfiguration
                        ? this.availableInternalOptions.findIndex((tag) => {
                            return tag.value === newNetwork.ipConfiguration.privateIpType;
                        })
                        : 0;

                    if (newNetwork.ipConfiguration) {
                        if (newNetwork.ipConfiguration.privateIpRange)
                            this.internalIp = newNetwork.ipConfiguration.privateIpRange;
                    }
                    this.availableExternalOptions[externalIndex].selected = true;
                    this.selectedExternal.push(extrnalTag[0].value);
                    this.availableInternalOptions[internalIndex].selected = true;
                    this.selectedInternal.push(internalTag[0].value);
                }
            }
        );

        this.$scope.$watch(
            () => this.selectedExternal,
            () => {
                this.showExternalAddresses = false;
                if (this.selectedExternal[0] === 'EXISTING') {
                    this.getExternalAddresses();
                }
            }
        );

        this.$scope.$watch(
            () => this.selectedInternal,
            () => {
                this.showInternalAddresses = false;
                this.showInternalIpAddress = this.selectedInternal[0] === 'STATIC';
            }
        );
    }

    getExternalAddresses() {
        this.busyNetwork = true;
        this.externalAddress = null;
        this.onGetExternal({ subscription: this.subscription })
            .then((res) => {
                this.allExternalAddresses = res.map((ea) => {
                    return {
                        value: ea.name,
                        label: ea.name,
                        resourceGroup: ea.resourceGroup,
                        subscriptionUuid: ea.subscriptionUuid,
                    };
                });
                this.externalAddresses = this.allExternalAddresses;
                if (
                    this.selectedNetwork &&
                    this.selectedNetwork.ipConfiguration &&
                    this.selectedNetwork.ipConfiguration.publicIp
                ) {
                    this.externalAddress = this.externalAddresses.filter(
                        (ea) => ea.value === this.selectedNetwork.ipConfiguration.publicIp.name
                    )[0];
                }
                this.showExternalAddresses = true;
            })
            .finally(() => {
                this.busyNetwork = false;
            });
    }

    getInternalAdresses() {
        this.busyNetwork = true;
        this.persistence
            .getInternalAddresses(this.project.value, this.region.value, this.network.value.subnetKey.subnetName)
            .then((res) => {
                this.internalAddresses = res;
                this.showInternalAddresses = true;
            })
            .finally(() => {
                this.busyNetwork = false;
            });
    }

    searchNetworks() {
        this.networksList = this.allNetworksList.filter(
            (network) => network.label.toLowerCase().indexOf(this.networkSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchSubnetworks() {
        this.subnetsList = this.allSubnets.filter(
            (subnet) => subnet.label.toLowerCase().indexOf(this.subnetSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchExternalAddresses() {
        this.externalAddresses = this.allExternalAddresses.filter(
            (externalAdd) =>
                externalAdd.label.toLowerCase().indexOf(this.externalAddSearch.searchBy.toLowerCase()) !== -1
        );
    }

    isAddDisabled() {
        return (
            !this.selectedNetwork ||
            !this.subnet ||
            (this.showExternalAddresses && !this.externalAddress) ||
            (this.showInternalIpAddress && !this.internalIp) ||
            (this.editMode && this.subnet && this.subnet.value === this.selectedNetwork.subnetType) ||
            this.isAdding
        );
    }
}

AddNetworkDialogController.$inject = ['$scope', '$timeout', '$filter', '$attrs', 'ecDeployPersistence'];

const addNetworkDialogComponent = {
    controller: AddNetworkDialogController,
    template: require('./addNetworkDialog.template.html'),
    bindings: {
        showModal: '=',
        title: '@?',
        allNetworksList: '=',
        selectedNetwork: '=?',
        onSave: '&',
        editMode: '<',
        isSubModal: '<?',
        subscription: '<?',
        availabilityZone: '<?',
        onGetExternal: '&?',
    },
};

module.exports = addNetworkDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/ecDeploy/addNetworkDialog/addNetworkDialog.component.js